import React from "react";
import cx from "classnames";
import { Col, Row, Button } from "reactstrap";

import AppConfig from "../../../../AppConfig";
import CodiaxHeader from "../CodiaxHeader/CodiaxHeader";

import ImgBg from "../assets/images/road.svg";

import s from "./CodiaxHelpPage.module.scss";

export default function CodiaxHelpPage() {
	const poapsUrl = `https://app.poap.xyz/scan`;

	const openUrl = (url) => {
		window.open(url, "_blank");
	};

	return (
		<div className={s.root}>
			<CodiaxHeader hideAvatar />

			<Row className={s.content}>
				<Col sm={6} className={s.left}>
					<div className={s.infoContainer}>
						<p className={s.title}>Help</p>
						<p className={s.description}>
							To participate in this workshop, you will need to install a
							Weavechain node and mint a POAP to your wallet.
						</p>
					</div>

					<div className={s.links}>
						<Button
							className={cx(s.button, "btn-border dark")}
							color="primary"
							onClick={() => openUrl(AppConfig.INSTALLATION_URL)}
						>
							How to Install a Weavechain Node
						</Button>
						<Button
							className={cx(s.button, "btn-border dark")}
							color="primary"
							onClick={() => openUrl(poapsUrl)}
						>
							See my POAPs
						</Button>

						{/* <Link to={"/"}>
							<Button
								className={cx(s.button, "btn-border dark")}
								color="primary"
							>
								Mint POAP
							</Button>
						</Link>

						<Link to={"/login"}>
							<Button
								className={cx(s.button, "btn-border dark")}
								color="primary"
								onClick={logout}
							>
								Connect with Metamask
							</Button>
						</Link>

						<Link to={"/data"}>
							<Button
								className={cx(s.button, "btn-border dark")}
								color="primary"
							>
								Enter Workshop to Read Data
							</Button>
						</Link> */}
					</div>
				</Col>

				<Col sm={6} className={s.right}>
					<img src={ImgBg} alt="logo" className={s.logo} />
				</Col>
			</Row>
		</div>
	);
}
